<template>
    <div class="index">

        <div class="news">

            <div class="star-nav ">

                <span class="pointer" @click="openIndex">首页</span>

                <span> / </span>

                <span>资讯详情</span>

            </div>

            <div class="new-content cf">

                <div class="news-left fl">

                    <div class="news-title">{{ news.name }}</div>

                    <div class="news-subtitle">

                        <span>文/{{news.author}}</span>

                        <span>{{ news.create_time }}</span>

                        <span>{{ news.click_count }}次阅读</span>

                    </div>

                    <div class="news-content v-html" v-html="news.content"></div>

                    <div class="guide">

                        <div class="guide-top cf">

                            <div
                                v-for="(item,index) in guide"
                                class="guide-item fl relative"
                                :key="'guide-item-'+index"
                            >

                                <img class="absolute" :src="item.image"/>

                                <div class="absolute">{{ item.name }}</div>

                            </div>

                        </div>

                        <div class="guide-bottom cf">

                            <div class="fl guide-logo cf">

                                <img class="logo-img fl" src="./images/img_logo@2x.png" />

                                <div class="logo-text fl">

                                    <div>文娱中国APP</div>

                                    <div class="score cf">

                                        <img
                                            class="fl"
                                            src="./images/icon_star@2x.png"
                                            v-for="index in 5"
                                            :key="'star-img-'+index"
                                        />

                                    </div>

                                </div>

                            </div>

                            <div class="fl guide-download cf">

                                <div class="fl guide-download-btn pointer" @click="openStore">

                                    <img src="../../assets/images/fixed/icon_ios_big@2x.png" />

                                    <span>IOS下载</span>

                                </div>

                                <div class="fl guide-download-btn pointer">

                                    <img src="../../assets/images/fixed/icon_android_white@2x.png" />

                                    <span>Android下载</span>

                                </div>

                            </div>

                            <div class="guide-image fl">

                                <img :src="download_img" />

                                <div>扫一扫下载</div>

                            </div>

                        </div>

                    </div>

                    <div class="news-comment">

                        <div class="news-comment-header cf">

                            <div class="fl news-comment-header-title">评论列表 <span>{{news.comment_count}}</span></div>

                            <div v-if="!$store.state.user.token" class="fr news-comment-header-right"><span @click="openLogin">登录</span>后可评论</div>

                        </div>

                        <div class="news-comment-content">

                            <layout-comment-input
                                :id="id"
                                :type="6"
                            />

                            <layout-comment-item
                                v-for="(item,index) in comment_list"
                                :key="'news-comment-item-'+index"
                                :data="item"
                            />

                        </div>

                        <layout-more
                            :status="status_comment"
                            @load="loadInfo"
                        />

                    </div>

                </div>

                <div class="news-right fr">

                    <layout-right-list :data="info" />

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import LayoutRightList from '@/layout/layout-right-list/main';
import LayoutCommentInput from '@/layout/layout-comment-input/main';
import LayoutCommentItem from '@/layout/layout-comment-item/main';
import LayoutMore from '@/layout/layout-more/main';

export default {
    name: "news-detail",
    mixins: [mixin],
    components: {
        LayoutRightList,
        LayoutCommentInput,
        LayoutCommentItem,
        LayoutMore
    }
}
</script>

<style scoped src="./style.css"></style>
